import script from "./ToggleButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToggleButton.vue?vue&type=script&setup=true&lang=ts"

import "./ToggleButton.vue?vue&type=style&index=0&id=71f0e78f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71f0e78f"]])

export default __exports__